/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const support = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m1 7.285 3.338.34c.363.039.71.182.998.414l2.646 2.141c.33.256.535.651.557 1.08a.952.952 0 0 1-.241.716M4.952 10.95l1.715 1.12c.397.275.9.32 1.335.12a.889.889 0 0 0 .296-.214M1 11.685l5.13 2.896c.293.134.623.194.952.172 4.987-.579 7.48-1.427 7.48-1.427 0-1.013-1.002-1.358-1.599-1.35H8.298m2.03-3.476L6.64 4.69a2.146 2.146 0 0 1-.41-2.495 2.195 2.195 0 0 1 3.494-.562l.603.596.602-.596a2.195 2.195 0 0 1 3.494.562c.42.831.256 1.836-.408 2.494L10.327 8.5Z"
    />
  </svg>
)
export default support
